var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page-icon"},[_c('div',{staticClass:"page-icon-image-wrapper"},[(_vm.props.image)?_c('img',{attrs:{"src":require(("@/assets/project-valuation-external-report/" + (_vm.props.image))),"alt":_vm.props.image}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }